document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.custom-timeline-section').forEach(function(section) {
    var sliderHolder = section.querySelector('.css-slider-holder');
    var cards = section.querySelectorAll('.custom-timeline-card');
    var years = section.querySelectorAll('.custom-timeline-year-label');
    var leftBtn = section.querySelector('.css-slider-prev');
    var rightBtn = section.querySelector('.css-slider-next');
    var current = 0;

    function updateYearsActive(idx) {
      years.forEach(function(year, i) {
        year.classList.toggle('is-active', i === idx);
      });
      cards.forEach(function(card, i) {
        card.classList.toggle('is-active', i === idx);
      });
      current = idx;
    }

    function scrollToCard(idx) {
      if (!sliderHolder || !cards[idx]) return;
      sliderHolder.scrollTo({
        left: cards[idx].offsetLeft,
        behavior: 'smooth'
      });
      updateYearsActive(idx);
    }

    years.forEach(function(year, i) {
      year.addEventListener('click', function() {
        scrollToCard(i);
      });
    });

    if (leftBtn) {
      leftBtn.addEventListener('click', function() {
        if (current > 0) scrollToCard(current - 1);
      });
    }
    if (rightBtn) {
      rightBtn.addEventListener('click', function() {
        if (current < cards.length - 1) scrollToCard(current + 1);
      });
    }

    // 支持滑动切换
    var startX = 0, endX = 0;
    if (sliderHolder) {
      sliderHolder.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; });
      sliderHolder.addEventListener('touchend', function(e) {
        endX = e.changedTouches[0].clientX;
        if (endX - startX > 50 && current > 0) scrollToCard(current - 1);
        if (startX - endX > 50 && current < cards.length - 1) scrollToCard(current + 1);
      });
    }

    // 初始化时对齐第一个
    scrollToCard(0);
  });
}); 